import React from "react";
import { useKeycloak } from "../../KeycloakProvider";
import { Box, Button, Typography, Paper } from "@mui/material";

const LoginPage = () => {
  const { keycloak } = useKeycloak();

  const handleLogin = () => {
    keycloak.login({
      redirectUri: window.location.href,
    });
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "background.default" }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 420, width: "100%", textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>Login</Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Login to access the M4D-CTI dashboard.
        </Typography>
        <Button variant="contained" fullWidth onClick={handleLogin}>
          Login with Keycloak
        </Button>
      </Paper>
    </Box>
  );
};

export default LoginPage;
